import {
    createRegisterableComposition,
    mapArticle,
    RequiredAccess,
    useToggleState,
} from '@news-mono/web-common'
import { ArticleLikeV4DTO } from '@west-australian-newspapers/publication-types'
import { PageProps } from '@west-australian-newspapers/page-lifecycle-provider'
import React from 'react'
import { getPublicationPageProperties } from '../../templates/Publication/lib/publication-page-properties'
import { getPublicationInfoFromRouteResolution } from '../../templates/Publication/SharedPublication.routing'
import { ShorthandBreach } from './ShorthandBreach'

export interface ShorthandBreachCompositionRegistrationProps {
    requiredAccess: RequiredAccess
    article: ArticleLikeV4DTO
}

export const ShorthandBreachCompositionRegistration =
    createRegisterableComposition<'main' | 'breach'>()(
        'shorthand-breach-composition',
        (
            contentAreas,
            props: ShorthandBreachCompositionRegistrationProps,
            services,
        ) => {
            const publicationInfo =
                getPublicationInfoFromRouteResolution(services)
            const toggleState = useToggleState()
            const article = mapArticle(props.article, toggleState)

            return (
                <PageProps
                    pageProperties={getPublicationPageProperties(
                        publicationInfo.publication,
                    )}
                >
                    <ShorthandBreach
                        requiredAccess={props.requiredAccess}
                        location={services.location}
                        onEvent={services.onEvent}
                        breach={contentAreas.breach}
                        article={article}
                        log={services.log}
                    >
                        {contentAreas.main}
                    </ShorthandBreach>
                </PageProps>
            )
        },
    )
